// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond48Filled: FC<Diamond48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="m8.65 11.95-3.6-3.5 2.15-2.2 3.55 3.6-2.1 2.1Zm13.95-3.9V3h3v5.05h-3Zm16.8 3.9-2.1-2.1 3.6-3.6 2.1 2.2-3.6 3.5ZM24.1 43 7.5 26.7h33.2L24.1 43ZM16 13.35h16.15L40.7 23.7H7.5L16 13.35Z" />
        </svg>
    );
};

export default Diamond48Filled;
